export enum DaysNoticeEnums {//Días aviso 
    sinAviso = 0,
    unDiasAntes = 1,
    dosDiasAntes = 2,
    tresDiasAntes = 3,
    cuatroDiasAntes = 4,
    cincoDiasAntes = 5,
}

export enum FrequencyEnums {//Frecuencia
    ninguna = 0,
    semanal = 1,
    mensual = 2,
    anual = 3
}

export enum StatusDateEnum {
    programada = 0,
    vencida = 1,
    aTiempo = 2,
}